import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { AcceptInvitation } from './model';
import {
    VALIDATION_TOKEN,
    VALIDATION_ALREADY_ACTIVE,
    VALIDATION_DEACTIVATED_ORG,
    VALIDATION_DEACTIVATED_USER
} from './invitationerrors';

import { CommonInvitationErrorsView } from './invitationerrorsview';
import { ProfileAndLandingPageLinks } from './invitationlinks';
import { LoginView } from 'portcall/login/view';
import { PasswordEntry } from 'portcall/passwordentry/view';
import { ValidationErrorView } from 'core/validationerror/view';

export const AcceptInvitationView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <div className="acceptinvitation pc-page-fixedwidth">
        {m.CheckInvitationResponse() ?
            m.CheckInvitationResponse()!.Success ?
                <CheckInvitationSuccessView model={m} /> :
                <InvitationErrorsView model={m} /> :
            null // TH: TODO -- <loadingindicator params="request: CheckInvitation" />
        }
        <LoginView modelContainer={m.Login} />
    </div>
);

let CheckInvitationSuccessView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    m.AcceptInvitationResponse() && m.AcceptInvitationResponse()!.Success ?
        <RegistrationSuccessView model={m} /> :
        m.AcceptInvitationValidation()[VALIDATION_TOKEN] ||
        m.AcceptInvitationValidation()[VALIDATION_DEACTIVATED_ORG] ||
        m.AcceptInvitationValidation()[VALIDATION_DEACTIVATED_USER] ||
        m.AcceptInvitationValidation()[VALIDATION_ALREADY_ACTIVE] ?
            <InvitationErrorsView model={m} /> :
            <AcceptInvitationForm model={m} />
);

let AcceptInvitationForm = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <form className="pc-card small-width">
        <h2 className="pc-card-header pc-card-title">Complete registration</h2>
        <div className="registration-field">
            Please enter the information below to complete your registration.
        </div>
        <FirstNameView model={m} />
        <LastNameView model={m} />
        <PasswordInputView model={m} />
        <ConfirmPasswordView model={m} />
        <div className="registration-button">
            <button className="pc-button" onClick={noDefault(m.Submit)}>Complete</button>
        </div>
    </form>
);

let FirstNameView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <div className="registration-field">
        <input className="form-control pc-input-box"
            placeholder="First name"
            value={m.AcceptInvitation.FirstName()}
            onChange={e => m.AcceptInvitation.FirstName(e.currentTarget.value)}
            autoFocus />
        <ValidationErrorView error={() => m.AcceptInvitationValidation()['FirstName']} />
    </div>
);

let LastNameView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <div className="registration-field">
        <input className="form-control pc-input-box"
            placeholder="Last name"
            value={m.AcceptInvitation.LastName()}
            onChange={e => m.AcceptInvitation.LastName(e.currentTarget.value)} />
        <ValidationErrorView error={() => m.AcceptInvitationValidation()['LastName']} />
    </div>
);

let PasswordInputView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <div className="registration-field">
        <PasswordEntry
            value={m.AcceptInvitation.Password}
            showValidation={m.ShowPasswordValidation}
            placeholder="Password" />
        <ValidationErrorView error={() => m.AcceptInvitationValidation()['Password']} />
    </div>
);

let ConfirmPasswordView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <div className="registration-field">
        <input type="password" className="form-control pc-input-box"
            placeholder="Confirm password"
            value={m.AcceptInvitation.ConfirmPassword() || ''}
            onChange={e => m.AcceptInvitation.ConfirmPassword(e.currentTarget.value)} />
        <ValidationErrorView error={() => m.AcceptInvitationValidation()['ConfirmPassword']} />
    </div>
);

let RegistrationSuccessView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <div className="pc-card small-width">
        <div className="result-description">
            Congratulations! Your registration is complete. 
        </div>
        <ProfileAndLandingPageLinks model={m} />
        <TrainingLink />
    </div>
);

let InvitationErrorsView = SuperCritical(({ model: m } : { model : AcceptInvitation }) =>
    <div className="pc-card large-width">
        <CommonInvitationErrorsView model={m}
            getError={key => m.AcceptInvitationValidation()[key] || m.CheckInvitationValidation()[key]}
            tokenErrorText="If you've already created your account, try logging in." />
        <TrainingLink />
    </div>
);

let TrainingLink = SuperCritical(() =>
    <div className="link-shell">
        {/* TH 12/15/2016 -- TODO: Should this URL be configurable? */}
        <a href="http://portcall.com/training/" target="_blank">View the online training</a>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/acceptinvitation/view.tsx